import { toast } from "react-toastify";

export const SuccessNotify = (msg) => {
  toast.success(msg, {
    position: "top-right",
  });
};

export const ErrorNotify = (msg) => {
  toast.error(msg, {
    position: "top-right",
  });
};
